import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import TextArea from '@bibliocommons/text-area';
import RadioButton from '@bibliocommons/base-radio-button';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';
import { FEELINGS } from 'app/constants/PreviewConstants';

import './FeedbackForm.scss';

const COMMENT_MAX_LENGTH = 4000;

function getBrowserInformation() {
  return {
    screenResolution: `${window.screen.width} x ${window.screen.height}`,
    viewportSize: `${window.outerWidth} x ${window.outerHeight}`,
    referer: window.location.href,
    userAgent: window.navigator.userAgent
  };
}

export default class FeedbackForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        comment: '',
        feeling: ''
      }
    };

    bindAll(this);
  }

  handleComment(comment) {
    this.setState(state => ({
      formData: {
        ...state.formData,
        comment
      }
    }));
  }

  handleFeeling(feeling) {
    this.setState(state => ({
      formData: {
        ...state.formData,
        feeling
      }
    }));
  }

  handleSubmit(e) {
    if (e) {
      e.preventDefault();
    }

    this.props.previewActions.submitFeedback({
      featureName: this.props.featureName,
      feedback: {
        ...this.state.formData,
        ...getBrowserInformation(),
        category: this.props.featureName,
        optIn: true
      },
      postSuccess: () => {
        this.props.handleClose();
      }
    });
  }

  isFormValid() {
    const { comment, feeling } = this.state.formData;
    return !!comment && !!feeling;
  }

  renderFeelingsField() {
    const renderOptions = FEELINGS.map(feeling => (
      <RadioButton
        required
        checked={feeling === this.state.formData.feeling}
        className={`${feeling}-feedback`}
        handleChange={this.handleFeeling}
        key={feeling}
        label={<FormattedMessage id={`${feeling}`} />}
        name="feelings"
        value={feeling}
      />
    ));

    return (
      <div className="feelings-field">
        <div className="feelings-label">
          <FormattedMessage id={`${this.props.featureName}_experience`} />
        </div>
        {renderOptions}
      </div>
    );
  }

  renderCommentBox() {
    return (
      <TextArea
        className="feedback-comment"
        dataKey="feedback-comment"
        label={<FormattedMessage id="your_comments" />}
        maxLength={COMMENT_MAX_LENGTH}
        minHeight="9rem"
        handleChange={this.handleComment}
        required
        value={this.state.formData.comment}
      />
    );
  }

  renderSubmitFeedbackButton() {
    const { featureName, previewTransactions } = this.props;

    return (
      <TransactionalSolidButton
        disabled={!this.isFormValid()}
        dataKey="submit-feedback-button"
        handleClick={this.handleSubmit}
        isLoading={previewTransactions.get([featureName, 'isLoading'], false)}
      >
        <FormattedMessage id="button_submit" />
      </TransactionalSolidButton>
    );
  }

  render() {
    return (
      <form className="cp-feedback-modal-form" onSubmit={this.handleSubmit}>
        <ModalHeader title={<FormattedMessage id="give_feedback" />} />
        <ModalContent>
          {this.renderFeelingsField()}
          {this.renderCommentBox()}
        </ModalContent>
        <ModalFooter renderPrimaryAction={this.renderSubmitFeedbackButton} />
      </form>
    );
  }
}

FeedbackForm.propTypes = {
  featureName: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  previewActions: PropTypes.objectOf(PropTypes.func).isRequired,
  previewTransactions: ImmutablePropTypes.map.isRequired
};
